export const insertTextarea = (textarea: HTMLTextAreaElement | null, text: string) => {
    if (!textarea) return '';
    const position = textarea.selectionStart;
    textarea.setRangeText(text, position, position);
    textarea.setSelectionRange(position + text.length, position + text.length);
    textarea.focus();
    return textarea.value;
}